customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        (super(), (this.originalButtonText = ""), (this.persistentTextActive = !1));
      }
      connectedCallback() {
        setTimeout(() => {
          if (((this.form = this.querySelector("form")), !this.form)) return;
          const t = this.variantIdInput;
          if (
            (t && (t.disabled = !1),
            this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
            (this.cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer")),
            (this.submitButton = this.querySelector('[type="submit"]')),
            this.submitButton)
          ) {
            if (
              ((this.submitButtonText = this.submitButton.querySelector(".button-text")),
              this.submitButtonText &&
                ((this.originalButtonText = this.submitButtonText.textContent),
                (this.submitButton.dataset.originalText = this.originalButtonText)),
              "true" === this.submitButton.dataset.textOverride && this.submitButtonText)
            ) {
              // Use persistent text when text override is active
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            else if (this.submitButton.classList.contains("has-persistent-text") && this.submitButtonText) {
              this.persistentTextActive = !0;
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              const t = this.submitButton.dataset.persistentText;
              if (t) {
                if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                  this.submitButtonText.textContent = t;
                }
                localStorage.setItem("addToCartButtonText", t);
              } else {
                const t = localStorage.getItem("addToCartButtonText");
                if (t) {
                  if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                    this.submitButtonText.textContent = t;
                  }
                  this.submitButton.dataset.persistentText = t;
                }
              }
            }
            ((this.persistentTextActive || "true" === this.submitButton.dataset.textOverride) &&
              this.submitButtonText &&
              this.setupButtonTextObserver(),
              document.querySelector("cart-drawer") && this.submitButton.setAttribute("aria-haspopup", "dialog"),
              (this.hideErrors = "true" === this.dataset.hideErrors),
              document.addEventListener("variant:change", this.handleVariantChange.bind(this)));
          }
        }, 100);
      }
      setupButtonTextObserver() {
        if (!this.submitButtonText) return;
        const t = { characterData: !0, childList: !0, subtree: !0 };
        if (this.persistentTextActive) {
          const e = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
          if (!e) return;
          const showPrice = "true" === this.submitButton.dataset.showPrice;
          ((this.buttonTextObserver = new MutationObserver((t) => {
            const currentText = this.submitButtonText.textContent.trim();
            const persistentText = e.trim();
            if (showPrice) {
              if (!currentText.startsWith(persistentText)) {
                this.submitButtonText.textContent = e;
              }
            } else {
              if (currentText !== persistentText) {
                this.submitButtonText.textContent = e;
              }
            }
          })),
            this.buttonTextObserver.observe(this.submitButtonText, t));
        }
      }
      handleVariantChange(t) {
        this.submitButtonText &&
          setTimeout(() => {
            if (this.persistentTextActive) {
              const showPrice = "true" === this.submitButton.dataset.showPrice;
              if (!showPrice) {
                const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
                t && (this.submitButtonText.textContent = t);
              }
            }
          }, 50);
      }
      getSubscribeSaveSelection() {
        const activeToggle = document.querySelector(".subscribe-save-wrapper-dynamic .subscribe-toggle-dynamic:checked, .subscribe-save-wrapper input[type='checkbox']:checked");
        const wrapper =
          activeToggle?.closest(".subscribe-save-wrapper-dynamic, .subscribe-save-wrapper") ||
          document.querySelector(".subscribe-save-wrapper-dynamic, .subscribe-save-wrapper");
        if (!wrapper) return null;

        const toggle = wrapper.querySelector(".subscribe-toggle-dynamic, input[type='checkbox']");
        const dropdown = wrapper.querySelector(".subscribe-frequency-dropdown");
        const planId =
          wrapper.dataset.sellingPlanId ||
          toggle?.dataset?.planId ||
          (dropdown && dropdown.value ? dropdown.value.trim() : "");

        return planId ? { wrapper, toggle, dropdown, planId } : null;
      }
      isSubscribeSaveActive() {
        const sellingPlanInput = this.form?.querySelector('input[name="selling_plan"]');
        if (sellingPlanInput?.value?.trim()) return true;
        return Boolean(
          document.querySelector(".subscribe-save-wrapper-dynamic .subscribe-toggle-dynamic:checked, .subscribe-save-wrapper input[type='checkbox']:checked"),
        );
      }
      shouldShowSubscribeSavePrompt() {
        if (!this.form || this.closest("quick-add-modal")) return false;
        if (this.isSubscribeSaveActive()) return false;
        return Boolean(this.getSubscribeSaveSelection());
      }
      ensureSubscribeSavePromptStyles() {
        if (document.getElementById("aifufand-subscribe-prompt-style")) return;
        const style = document.createElement("style");
        style.id = "aifufand-subscribe-prompt-style";
        style.textContent = `
          .aifufand-subscribe-prompt {
            position: fixed;
            inset: 0;
            z-index: 2147483000;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 20px;
            background: rgba(18, 24, 33, 0.58);
          }
          body.aifufand-subscribe-prompt-open {
            overflow: hidden;
          }
          .aifufand-subscribe-prompt__dialog {
            width: min(100%, 338px);
            border-radius: 16px;
            background: #ffffff;
            color: #132235;
            padding: 34px 24px 30px;
            text-align: center;
            box-shadow: 0 18px 48px rgba(0, 0, 0, 0.22);
          }
          .aifufand-subscribe-prompt__badge {
            display: block;
            width: 72px;
            height: 72px;
            margin: -4px auto 18px;
            border-radius: 50%;
            object-fit: contain;
          }
          .aifufand-subscribe-prompt__title {
            margin: 0 0 14px;
            color: #132235;
            font-size: 24px;
            font-weight: 800;
            line-height: 1.12;
            letter-spacing: 0;
          }
          .aifufand-subscribe-prompt__body {
            margin: 0 0 26px;
            color: #555d68;
            font-size: 15px;
            line-height: 1.45;
            letter-spacing: 0;
          }
          .aifufand-subscribe-prompt__highlight {
            color: #005bd3;
            font-weight: 800;
          }
          .aifufand-subscribe-prompt__confirm {
            width: 100%;
            min-height: 52px;
            border: 0;
            border-radius: 8px;
            background: #005bd3;
            color: #ffffff;
            font: inherit;
            font-size: 16px;
            font-weight: 800;
            line-height: 1.2;
            letter-spacing: 0;
            cursor: pointer;
            box-shadow: 0 7px 14px rgba(0, 91, 211, 0.25);
          }
          .aifufand-subscribe-prompt__confirm:hover {
            background: #004fbd;
          }
          .aifufand-subscribe-prompt__decline {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            margin-top: 22px;
            padding: 0;
            border: 0;
            background: transparent;
            color: #858585;
            font: inherit;
            font-size: 14px;
            font-weight: 700;
            letter-spacing: 0;
            cursor: pointer;
          }
          .aifufand-subscribe-prompt__decline:hover {
            color: #555d68;
          }
          @media (max-width: 480px) {
            .aifufand-subscribe-prompt {
              padding: 18px;
            }
            .aifufand-subscribe-prompt__dialog {
              width: min(100%, 336px);
              padding: 32px 24px 28px;
            }
            .aifufand-subscribe-prompt__title {
              font-size: 23px;
            }
          }
        `;
        document.head.appendChild(style);
      }
      getSubscribePromptIconUrl() {
        const script =
          document.currentScript ||
          document.querySelector('script[src*="product-form.js"]') ||
          document.querySelector('script[src*="/assets/product-form"]');
        const sourceUrl = script?.src || "";
        if (sourceUrl) {
          return sourceUrl.replace(/product-form\.js(\?[^#]*)?(#.*)?$/, "subscribe-save-prompt-icon.webp$1$2");
        }
        return "subscribe-save-prompt-icon.webp";
      }
      setSubscribeSavePlan(planId) {
        let sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
        if (!sellingPlanInput) {
          sellingPlanInput = document.createElement("input");
          sellingPlanInput.type = "hidden";
          sellingPlanInput.name = "selling_plan";
          this.form.appendChild(sellingPlanInput);
        }
        sellingPlanInput.value = planId || "";
        sellingPlanInput.setAttribute("value", planId || "");
      }
      clearSubscribeSavePlan() {
        const sellingPlanInput = this.form?.querySelector('input[name="selling_plan"]');
        if (!sellingPlanInput) return;
        sellingPlanInput.value = "";
        sellingPlanInput.setAttribute("value", "");
      }
      activateSubscribeSaveFromPrompt() {
        const selection = this.getSubscribeSaveSelection();
        if (!selection) return false;

        if (selection.dropdown && selection.dropdown.value !== selection.planId) {
          selection.dropdown.value = selection.planId;
        }
        if (selection.toggle && !selection.toggle.checked) {
          selection.toggle.checked = true;
          selection.toggle.dispatchEvent(new Event("change", { bubbles: true }));
        } else if (selection.dropdown) {
          selection.dropdown.dispatchEvent(new Event("change", { bubbles: true }));
        }
        this.setSubscribeSavePlan(selection.planId);
        return true;
      }
      closeSubscribeSavePrompt(prompt, previousActiveElement) {
        if (!prompt) return;
        document.removeEventListener("keydown", prompt.aifufandKeyHandler);
        prompt.remove();
        document.body.classList.remove("aifufand-subscribe-prompt-open");
        if (previousActiveElement && typeof previousActiveElement.focus === "function") previousActiveElement.focus();
      }
      showSubscribeSavePrompt(event) {
        if (document.querySelector(".aifufand-subscribe-prompt")) return;

        this.ensureSubscribeSavePromptStyles();
        const iconUrl = this.getSubscribePromptIconUrl();
        const previousActiveElement = document.activeElement;
        const prompt = document.createElement("div");
        prompt.className = "aifufand-subscribe-prompt";
        prompt.setAttribute("role", "presentation");
        prompt.innerHTML = `
          <div class="aifufand-subscribe-prompt__dialog" role="dialog" aria-modal="true" aria-labelledby="aifufand-subscribe-prompt-title">
            <img class="aifufand-subscribe-prompt__badge" src="${iconUrl}" alt="" width="72" height="72" loading="eager" aria-hidden="true">
            <h2 class="aifufand-subscribe-prompt__title" id="aifufand-subscribe-prompt-title">Wait! Don't lose your savings</h2>
            <p class="aifufand-subscribe-prompt__body">
              Subscribe now to save <span class="aifufand-subscribe-prompt__highlight">15%</span> on this order and keep refills easy.
            </p>
            <button type="button" class="aifufand-subscribe-prompt__confirm">Yes, Subscribe &amp; Save 15%</button>
            <button type="button" class="aifufand-subscribe-prompt__decline">No thanks, add to cart</button>
          </div>
        `;

        const continueWithCartAdd = () => {
          this.closeSubscribeSavePrompt(prompt, previousActiveElement);
          this.submitCartForm(event);
        };

        prompt.querySelector(".aifufand-subscribe-prompt__confirm")?.addEventListener("click", () => {
          this.activateSubscribeSaveFromPrompt();
          window.setTimeout(continueWithCartAdd, 25);
        });
        prompt.querySelector(".aifufand-subscribe-prompt__decline")?.addEventListener("click", () => {
          this.clearSubscribeSavePlan();
          continueWithCartAdd();
        });
        prompt.aifufandKeyHandler = (keyEvent) => {
          if (keyEvent.key === "Escape") {
            keyEvent.preventDefault();
            this.closeSubscribeSavePrompt(prompt, previousActiveElement);
          }
        };
        document.addEventListener("keydown", prompt.aifufandKeyHandler);

        document.body.appendChild(prompt);
        document.body.classList.add("aifufand-subscribe-prompt-open");
        prompt.querySelector(".aifufand-subscribe-prompt__confirm")?.focus();
      }
      ensureSellingPlanValue() {
        let planIdToUse = null;
        try {
          const sellingPlanInput = this.form.querySelector('input[name="selling_plan"]');
          if (sellingPlanInput) {
            if (sellingPlanInput.value) {
              planIdToUse = sellingPlanInput.value;
            } else {
              const subscribeToggle = document.querySelector('.subscribe-save-wrapper input[type="checkbox"]:checked, .subscribe-save-wrapper-dynamic input[type="checkbox"]:checked');
              if (subscribeToggle) {
                const wrapper = subscribeToggle.closest('.subscribe-save-wrapper, .subscribe-save-wrapper-dynamic');
                if (wrapper) {
                  const frequencyDropdown = wrapper.querySelector('.subscribe-frequency-dropdown');
                  planIdToUse = wrapper.dataset.sellingPlanId || subscribeToggle.dataset.planId || (frequencyDropdown && frequencyDropdown.value ? frequencyDropdown.value.trim() : '');
                }
                
                if (planIdToUse) {
                  sellingPlanInput.value = planIdToUse;
                  sellingPlanInput.setAttribute('value', planIdToUse);
                }
              }
            }
          }
        } catch (error) {
          console.warn('⚠️ product-form.js: Error setting selling_plan:', error);
        }
        return planIdToUse;
      }
      onSubmitHandler(t) {
        t.preventDefault();
        if ("true" === this.submitButton.getAttribute("aria-disabled")) return;
        if (this.shouldShowSubscribeSavePrompt()) {
          this.showSubscribeSavePrompt(t);
          return;
        }
        this.submitCartForm(t);
      }
      submitCartForm(t) {
        if ("true" === this.submitButton.getAttribute("aria-disabled")) return;

        // Keep standard PDP, Sticky Add and Quick Add in the same cart-write
        // lane as the drawer. This wraps transport only; the successful
        // TikTok -> cartUpdate -> render sequence below is unchanged.
        const cartMutation = window.AifufandCartMutation;
        const mutation = cartMutation?.reserve({ type: "product-add" });
        if (cartMutation && !mutation) {
          this.handleErrorMessage(cartMutation.getBusyMessage());
          return;
        }

        let responseStatus;
        let retryAfter;
        try {
          const loadingSpinner = this.querySelector(".loading__spinner");
          (this.handleErrorMessage(),
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButton.classList.add("loading"),
            loadingSpinner?.classList.remove("hidden"));

          const e = fetchConfig("javascript");
          ((e.headers["X-Requested-With"] = "XMLHttpRequest"), delete e.headers["Content-Type"]);

          this.ensureSellingPlanValue();

          const s = new FormData(this.form);
          (this.cart &&
            (s.append(
              "sections",
              this.cart.getSectionsToRender().map((t) => t.id),
            ),
            s.append("sections_url", window.location.pathname),
            this.cart.setActiveElement(document.activeElement)),
            (e.body = s));

          if (mutation && !cartMutation.start(mutation)) {
            cartMutation.cancel(mutation);
            throw new Error("Cart mutation could not start");
          }

          fetch(`${routes.cart_add_url}`, e)
            .then((response) => {
              responseStatus = response.status;
              retryAfter = response.headers.get("Retry-After");
              return this.parseCartAddResponse(response);
            })
            .then(this.handleCartResponse.bind(this, s, t))
            .catch((error) => {
              console.error(error);
              this.error = true;
              if (this.submitButton) this.submitButton.removeAttribute("aria-disabled");
              this.handleErrorMessage(error.message || window.cartStrings?.error || "There was an error adding this item to your cart.");
            })
            .finally(() => {
              if (mutation) cartMutation.release(mutation, { status: responseStatus, retryAfter });
              this.handleSubmitFinally(t);
            });
        } catch (error) {
          if (mutation && cartMutation?.isCurrent(mutation)) {
            if (cartMutation.isReserved(mutation)) cartMutation.cancel(mutation);
            else cartMutation.release(mutation, { status: responseStatus, retryAfter });
          }
          this.error = true;
          if (this.submitButton) this.submitButton.removeAttribute("aria-disabled");
          this.handleErrorMessage(error.message || window.cartStrings?.error || "There was an error adding this item to your cart.");
          this.handleSubmitFinally(t);
        }
      }
      parseCartAddResponse(response) {
        return response.text().then((text) => {
          let data = {};
          try {
            data = text ? JSON.parse(text) : {};
          } catch (error) {
            const cartError = new Error(
              response.status === 429
                ? "Your cart is updating. Please wait a moment and try again."
                : `Invalid cart add response: ${error.message}`,
            );
            cartError.status = response.status;
            cartError.retryAfter = response.headers.get("Retry-After");
            throw cartError;
          }
          if (!response.ok && !data.status) {
            data.status = response.status;
            data.description = data.description || data.message || window.cartStrings?.error || "There was an error adding this item to your cart.";
          }
          return data;
        });
      }

      getTrackedLineItem(responseData) {
        if (!responseData) return null;
        if (Array.isArray(responseData.items)) {
          return responseData.items.find((item) => Number(item.final_price ?? item.price ?? 0) > 0) || responseData.items[0] || null;
        }
        return responseData;
      }
      getTrackedLineValue(lineItem) {
        const presentmentPrice = Number(lineItem?.presentment_price);
        if (Number.isFinite(presentmentPrice) && presentmentPrice > 0) return presentmentPrice;

        const cents = Number(lineItem?.final_price ?? lineItem?.discounted_price ?? lineItem?.price ?? 0);
        return Number.isFinite(cents) ? cents / 100 : 0;
      }
      getTikTokPixelId() {
        return window.aifufandTikTokPixelId || "D92D073C77U8UFHDD500";
      }
      ensureTikTokBrowserPixel(pixelId) {
        if (!pixelId) return null;
        if (typeof window.ttq?.track === "function") {
          if (typeof window.ttq.load === "function" && !window.ttq._i?.[pixelId]) window.ttq.load(pixelId);
          return window.ttq;
        }

        const objectName = "ttq";
        const ttq = (window[objectName] = window[objectName] || []);
        window.TiktokAnalyticsObject = objectName;
        ttq.methods = ttq.methods || [
          "page",
          "track",
          "identify",
          "instances",
          "debug",
          "on",
          "off",
          "once",
          "ready",
          "alias",
          "group",
          "enableCookie",
          "disableCookie",
          "holdConsent",
          "revokeConsent",
          "grantConsent",
        ];
        ttq.setAndDefer =
          ttq.setAndDefer ||
          ((target, method) => {
            target[method] = function () {
              target.push([method].concat(Array.prototype.slice.call(arguments, 0)));
            };
          });
        for (let index = 0; index < ttq.methods.length; index += 1) {
          if (!ttq[ttq.methods[index]]) ttq.setAndDefer(ttq, ttq.methods[index]);
        }
        ttq.load =
          ttq.load ||
          function (id, options) {
            const scriptUrl = "https://analytics.tiktok.com/i18n/pixel/events.js";
            ttq._i = ttq._i || {};
            ttq._i[id] = ttq._i[id] || [];
            ttq._i[id]._u = scriptUrl;
            ttq._t = ttq._t || {};
            ttq._t[id] = +new Date();
            ttq._o = ttq._o || {};
            ttq._o[id] = options || {};
            if (document.querySelector(`script[src*="${id}"][src*="analytics.tiktok.com/i18n/pixel/events.js"]`)) return;
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = `${scriptUrl}?sdkid=${id}&lib=${objectName}`;
            const firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(script, firstScript);
          };
        ttq.load(pixelId);
        return ttq;
      }
      trackTikTokAddToCartEvent(formData, responseData) {
        try {
          const lineItem = this.getTrackedLineItem(responseData);
          if (!lineItem) return;

          const quantity = Number(lineItem.quantity || formData.get("quantity") || 1);
          const variantId = String(lineItem.variant_id || formData.get("id") || lineItem.id || "");
          const productId = String(lineItem.product_id || lineItem.product?.id || "");
          const contentId = variantId || productId;
          if (!contentId) return;

          const productTitle = lineItem.product_title || lineItem.title || document.querySelector("h1")?.textContent?.trim() || "";
          const currencyCode = window.Shopify?.currency?.active || window.Shopify?.currency?.currentCurrency || "USD";
          const itemPrice = this.getTrackedLineValue(lineItem);
          const value = Number((itemPrice * (Number.isFinite(quantity) && quantity > 0 ? quantity : 1)).toFixed(2));
          const eventKey = `${lineItem.key || variantId}:${quantity}:${value}`;
          const now = Date.now();
          if (this.aifufandLastTikTokAddToCart?.key === eventKey && now - this.aifufandLastTikTokAddToCart.time < 3000) return;
          this.aifufandLastTikTokAddToCart = { key: eventKey, time: now };

          const payload = {
            content_id: contentId,
            content_type: "product",
            content_name: productTitle,
            currency: currencyCode,
            value,
            quantity,
            contents: [
              {
                content_id: contentId,
                content_type: "product",
                content_name: productTitle,
                quantity,
                price: itemPrice,
              },
            ],
          };
          const ttq = this.ensureTikTokBrowserPixel(this.getTikTokPixelId());
          if (ttq && typeof ttq.track === "function") ttq.track("AddToCart", payload);
        } catch (error) {
          window.aifufandDebug && window.aifufandDebug("TikTok AddToCart tracking failed:", error);
        }
      }
      handleCartResponse(formData, event, responseData) {
        if (responseData.status) {
          (publish(PUB_SUB_EVENTS.cartError, {
            source: "product-form",
            productVariantId: formData.get("id"),
            errors: responseData.errors || responseData.description,
            message: responseData.message,
          }),
            this.handleErrorMessage(responseData.description));
          const e = this.submitButton.querySelector(".sold-out-message");
          if (!e) return;
          return (
            this.submitButton.setAttribute("aria-disabled", !0),
            this.submitButtonText.classList.add("hidden"),
            e.classList.remove("hidden"),
            void (this.error = !0)
          );
        }
        this.trackTikTokAddToCartEvent(formData, responseData);
        if (!this.cart) return void (window.location = window.routes.cart_url);
        const e = CartPerformance.createStartingMarker("add:wait-for-subscribers");
        (this.error ||
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: formData.get("id"),
            cartData: responseData,
          }).then(() => {
            CartPerformance.measureFromMarker("add:wait-for-subscribers", e);
          }),
          (this.error = !1));
        const i = this.closest("quick-add-modal");
        i
          ? (document.body.addEventListener(
              "modalClosed",
              () => {
                setTimeout(() => {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(responseData);
                  });
                });
              },
              { once: !0 },
            ),
            i.hide(!0))
          : CartPerformance.measure("add:paint-updated-sections", () => {
              this.cart.renderContents(responseData);
            });
      }
      handleSubmitFinally(event) {
        if (
          (this.submitButton.classList.remove("loading"),
          this.cart && this.cart.classList.contains("is-empty") && this.cart.classList.remove("is-empty"),
          this.error || this.submitButton.removeAttribute("aria-disabled"),
          this.querySelector(".loading__spinner")?.classList.add("hidden"),
          this.error || "true" !== this.submitButton.dataset.textOverride)
        ) {
          if (!this.error && this.persistentTextActive) {
            const showPrice = "true" === this.submitButton.dataset.showPrice;
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t && this.submitButtonText) {
              if (!showPrice || !this.submitButtonText.textContent.trim().startsWith(t.trim())) {
                this.submitButtonText.textContent = t;
              }
            }
          }
        } else;
        CartPerformance.measureFromEvent("add:user-action", event);
      }
      handleErrorMessage(t = !1) {
        this.hideErrors ||
          ((this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message")),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t)));
      }
      toggleSubmitButton(t = !0, e) {
        if (t) (this.submitButton.setAttribute("disabled", "disabled"), e && (this.submitButtonText.textContent = e));
        else {
          if ((this.submitButton.removeAttribute("disabled"), "true" === this.submitButton.dataset.textOverride));
          else if (this.persistentTextActive) {
            const t = this.submitButton.dataset.persistentText || localStorage.getItem("addToCartButtonText");
            if (t) return void (this.submitButtonText.textContent = t);
          }
          this.originalButtonText
            ? (this.submitButtonText.textContent = this.originalButtonText)
            : this.submitButton.dataset.originalText
              ? (this.submitButtonText.textContent = this.submitButton.dataset.originalText)
              : (this.submitButtonText.textContent = window.variantStrings.addToCart);
        }
      }
      disconnectedCallback() {
        (this.buttonTextObserver && this.buttonTextObserver.disconnect(),
          document.removeEventListener("variant:change", this.handleVariantChange));
      }
      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
